import card01 from "./../assets/card/card01.webp";
import card02 from "./../assets/card/card02.webp";
import card03 from "./../assets/card/card03.webp";
import card04 from "./../assets/card/card04.webp";
import card05 from "./../assets/card/card05.webp";
import card06 from "./../assets/card/card06.webp";
import card07 from "./../assets/card/card07.webp";
import card08 from "./../assets/card/card08.webp";
import card09 from "./../assets/card/card09.webp";
import card10 from "./../assets/card/card10.webp";

export const cardData = [
  {
    image: card01,
    title: "6월 가입 이벤트",
  },
  {
    image: card02,
    title: "셀럽픽",
  },
  {
    image: card03,
    title: "남성 추천",
  },
  {
    image: card04,
    title: "여성 추천",
  },
  {
    image: card05,
    title: "기회의 주말",
  },
  {
    image: card06,
    title: "정가 아래",
  },
  {
    image: card07,
    title: "인기 럭셔리",
  },
  {
    image: card08,
    title: "장마 준비",
  },
  {
    image: card09,
    title: "6월 혜택 모음",
  },
  {
    image: card10,
    title: "무조건 포인트",
  },
];
